export * from 'server/models/PortCallDeletion';


// WEBPACK FOOTER //
// ./data/models/PortCallDeletion.ts